import React from 'react'
import Rewritetodo from './Components/Rewritetodo.js'
import './Components/Style.css'

function App() {
    return (

        <div className="container">
            <div className="row m-auto">
                <div className="col-sm-7 m-auto maincol">
                    <Rewritetodo />
                </div>
            </div>
        </div>
    )
}

export default App